var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "full_wrap", attrs: { id: "wrap" } }, [
    _c("div", { attrs: { id: "container" } }, [
      _c("div", { staticClass: "container_wrap" }, [
        _c("div", { staticClass: "msg_item" }, [
          _c("p", [
            _c("em", [
              _vm._v("The connection is delayed. Please try again later.")
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isLogin,
                    expression: "isLogin"
                  }
                ],
                staticClass: "btn_blue",
                attrs: { href: "javascript:" },
                on: { click: _vm.goMain }
              },
              [_vm._v("Click")]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f4c108f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4c108f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/common/ErrorPage.vue
// module id = PrCf
// module chunks = 0